import React from "react";
import "./Feedback.css";

function Feedback() {

  return (
    <div className="feedback-wrapper">
      <iframe
      src="https://tally.so/r/nGqDqo?transparentBackground=1"
      width="100%"
      height="100%"
      frameBorder="0"
      title="Ethereum México Feedback"
    ></iframe>

    </div>
  );
}

export default Feedback;
